"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What is your typical production timeline?",
  answer: "Every project is a unique cinematic endeavor. Generally, a high-end brand film takes 4 to 6 weeks from initial concept and storyboarding through to final color grading and sound design. We prioritize artistry over speed to ensure every frame demands attention."
}, {
  question: "Do you handle social media formatting?",
  answer: "Absolutely. We capture content with a 'multi-platform' mindset, delivering master files in cinematic 2.35:1 for web and high-impact 9:16 vertical crops for social platforms, ensuring your brand looks premium on every screen."
}, {
  question: "What equipment do you use for filming?",
  answer: "We utilize industry-standard cinema cameras and optics—think RED and Arri systems—paired with professional lighting rigs. Our technical approach provides that 'behind-the-lens' grit and high-grain texture that defines the Pivotal Placement aesthetic."
}, {
  question: "Can you provide live streaming services?",
  answer: "Yes. We bring our cinematic production value to the live space. Whether it's a product launch or a brand event, we provide multi-cam switching and professional audio feeds to create an immersive, real-time experience for your audience."
}, {
  question: "How do we start a collaboration?",
  answer: "The process begins with a vision alignment session. Visit our 'Start a Project' page to share your brief. We'll review your goals and determine how our cinematic brutalism can best elevate your brand's digital presence."
}];
export default function CommonQuestions() {
  return <section data-section-id="224143" id="common-inquiries" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground mb-4 tracking-tighter leading-none uppercase">
            Common Inquiries
          </h2>
          <p className="text-lg text-muted-foreground font-mono">
            Technical details and creative workflows for brands that demand cinematic excellence.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="bg-card border border-border rounded-none px-4 shadow-none">
              <AccordionTrigger className="font-default font-bold text-left text-base md:text-lg hover:no-underline hover:text-primary transition-colors py-5 uppercase tracking-tight">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-5 font-mono">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}